import {RETRIEVE_LANGS_ERROR, RETRIEVE_LANGS_REQUEST, RETRIEVE_LANGS_SUCCESS} from "./actions";
import {REHYDRATE} from 'redux-persist'


const initialState = {
    isLoading: false,
    languages: []
};

export default function langReducer(state = initialState, action) {
    switch (action.type) {
        case RETRIEVE_LANGS_REQUEST:
            return {...state, isLoading: true};
        case RETRIEVE_LANGS_SUCCESS:
            return {...state, isLoading: false, languages: [...action.languages]};
        case RETRIEVE_LANGS_ERROR:
            return {...state, isLoading: false};
        case REHYDRATE:
            if (action.payload) {
                const incoming = action.payload.lang;
                if (incoming) {
                    return {...state, languages: [...incoming.languages]};
                }
            }
            return state;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/languages/reducer.js